/*
 *   Copyright (c) 2022 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { CollectionListMessage } from "../../../messages";
import {toHeaderCase} from "js-convert-case";
const MODULE_NAME =
  "services.CollectionHomePageService.machines.GetCollectionList.state.formatCollectionChildren";
const log = LoggerModule?.getInstance();

export const formatCollectionChildren = async (context: any, event: any) => {
  return new Promise(async (resolve, reject) => {
    try {
      const msg = context?.input as CollectionListMessage;
      if (msg?.nodes?.data && msg?.collection?.collectionList) {
        for (const coll of msg?.nodes?.data) {
          msg.collection?.collectionList?.push({
            id: coll?.uuid,
            title:toHeaderCase(coll?.name ?? ""),
            description: coll?.description,
            image: coll?.logo ?? `https://ui-avatars.com/api/?name=${coll?.name}&background=0D8ABC&color=fff`,
            catalogueType: "catalogue",
            startDate: coll?.metaData?.startDate,
          });
        }
        msg.collection.totalCount = msg.nodes.totalCount;
        msg.collection.totalPages = msg.nodes.totalPages;
        msg.collection.currentPage = msg.nodes.currentPage;
      }
      return resolve(true);
    } catch (err: any) {
      log?.error(MODULE_NAME, "error in formatCollectionChildren", err);
      return reject(err?.message);
    }
  });
};
